module.exports = __webpack_public_path__ + "static/media/home-book-icon.8ca04813.png";